var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "actions-collapsed-list" },
    [
      _c(
        "a",
        {
          staticClass: "btn btn-function exit-collapsed-list",
          on: { click: _vm.collapseActions }
        },
        [
          _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.right.hover",
                value: _vm.$t("CANCEL"),
                expression: "$t('CANCEL')",
                modifiers: { right: true, hover: true }
              }
            ],
            staticClass: "glyphicon glyphicon-chevron-left",
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-list-function",
            attrs: {
              href: `#/dashboard/call-flow/edit/${_vm.currentCallFlow.id}`
            },
            on: {
              click: function($event) {
                return _vm.editCallFlow(_vm.currentCallFlow.id, $event)
              }
            }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom.hover",
                  value: _vm.$t("EDIT"),
                  expression: "$t('EDIT')",
                  modifiers: { bottom: true, hover: true }
                }
              ],
              staticClass: "typcn typcn-edit",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "EDIT",
                  expression: "'EDIT'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon m-t-2" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-list-function",
            attrs: { disabled: _vm.duplicateId === _vm.currentCallFlow.id },
            on: {
              click: function($event) {
                return _vm.duplicateCallFlow(_vm.currentCallFlow.id, $event)
              }
            }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom.hover",
                  value: _vm.$t("DUPLICATE"),
                  expression: "$t('DUPLICATE')",
                  modifiers: { bottom: true, hover: true }
                }
              ],
              staticClass: "fa fa-files-o",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "DUPLICATE",
                  expression: "'DUPLICATE'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-list-function",
            attrs: { "data-testid": "call-flow-action-delete" },
            on: {
              click: function($event) {
                return _vm.deleteCallFlow(_vm.currentCallFlow, $event)
              }
            }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom.hover",
                  value: _vm.$t("DELETE"),
                  expression: "$t('DELETE')",
                  modifiers: { bottom: true, hover: true }
                }
              ],
              staticClass: "typcn typcn-trash",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "DELETE",
                  expression: "'DELETE'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("ChangeLogObjectButtonAction", {
        attrs: {
          "object-id": _vm.currentCallFlow.id,
          "object-name": _vm.currentCallFlow.incomingQueryStringName,
          "object-type": "IVR"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }